/* Hero 3D: liquid chrome media objects (TV, camera, light, clapperboard, remote, tablet, phone, laptop)
   raymarched in a WebGL shader, melting from one into the next with chrome droplets orbiting. */
(function () {
  var canvas = document.getElementById('hero3d');
  if (!canvas) return;
  var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, powerPreference: 'high-performance' });
  if (!gl) return;

  var VS = 'attribute vec2 a; void main(){ gl_Position = vec4(a, 0.0, 1.0); }';
  var FS = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec2 uRes; uniform float uTime; uniform vec2 uMouse; uniform float uCamZ;',
    'uniform int uA; uniform int uB; uniform float uMix;',

    'mat2 rot(float a){ float c = cos(a), s = sin(a); return mat2(c, -s, s, c); }',
    'float smin(float a, float b, float k){ float h = clamp(0.5 + 0.5*(b - a)/k, 0.0, 1.0); return mix(b, a, h) - k*h*(1.0 - h); }',
    'float sdBox(vec3 p, vec3 b, float r){ vec3 q = abs(p) - b + r; return length(max(q, 0.0)) + min(max(q.x, max(q.y, q.z)), 0.0) - r; }',
    'float sdCylZ(vec3 p, float r, float h){ vec2 d = abs(vec2(length(p.xy), p.z)) - vec2(r, h); return min(max(d.x, d.y), 0.0) + length(max(d, 0.0)); }',
    'float sdCylY(vec3 p, float r, float h){ return sdCylZ(p.xzy, r, h); }',
    'float sdCylX(vec3 p, float r, float h){ return sdCylZ(p.zyx, r, h); }',
    'float sdCap(vec3 p, vec3 a, vec3 b, float r){ vec3 pa = p - a, ba = b - a; float h = clamp(dot(pa, ba)/dot(ba, ba), 0.0, 1.0); return length(pa - ba*h) - r; }',

    /* 0 TV with antennae */
    'float tv(vec3 p){',
    '  float body = sdBox(p - vec3(0.0, -0.05, 0.0), vec3(0.95, 0.72, 0.5), 0.16);',
    '  float scr = sdBox(p - vec3(-0.12, -0.05, 0.52), vec3(0.62, 0.5, 0.09), 0.14);',
    '  body = max(body, -scr);',
    '  float k1 = sdCylZ(p - vec3(0.72, 0.2, 0.5), 0.08, 0.06);',
    '  float k2 = sdCylZ(p - vec3(0.72, -0.15, 0.5), 0.08, 0.06);',
    '  float ant = min(sdCap(p, vec3(0.0, 0.62, 0.0), vec3(-0.5, 1.35, 0.0), 0.03), sdCap(p, vec3(0.0, 0.62, 0.0), vec3(0.55, 1.3, 0.0), 0.03));',
    '  float legs = min(sdCap(p, vec3(-0.6, -0.72, 0.0), vec3(-0.75, -1.05, 0.0), 0.04), sdCap(p, vec3(0.6, -0.72, 0.0), vec3(0.75, -1.05, 0.0), 0.04));',
    '  return min(smin(min(body, min(k1, k2)), ant, 0.1), legs);',
    '}',
    /* 1 Cinema camera with reels */
    'float cam(vec3 p){',
    '  p.xz *= rot(0.6);',
    '  float body = sdBox(p - vec3(0.0, -0.2, 0.0), vec3(0.45, 0.4, 0.72), 0.1);',
    '  float lens = sdCylZ(p - vec3(0.0, -0.2, 0.92), 0.25, 0.24);',
    '  float hood = sdCylZ(p - vec3(0.0, -0.2, 1.2), 0.33, 0.06);',
    '  float r1 = sdCylX(p - vec3(0.0, 0.58, -0.28), 0.38, 0.08);',
    '  float r2 = sdCylX(p - vec3(0.0, 0.46, 0.42), 0.3, 0.08);',
    '  float grip = sdBox(p - vec3(0.0, -0.78, -0.1), vec3(0.08, 0.2, 0.1), 0.05);',
    '  return min(min(smin(body, lens, 0.06), hood), min(min(r1, r2), grip));',
    '}',
    /* 2 Studio light on a tripod */
    'float lamp(vec3 p){',
    '  vec3 q = p - vec3(0.0, 0.45, 0.0); q.yz *= rot(-0.35);',
    '  float can = sdCylZ(q, 0.48, 0.42);',
    '  can = max(can, -sdCylZ(q - vec3(0.0, 0.0, 0.45), 0.38, 0.07));',
    '  float yoke = min(min(sdCap(p, vec3(-0.56, 0.45, 0.0), vec3(-0.56, -0.12, 0.0), 0.045), sdCap(p, vec3(0.56, 0.45, 0.0), vec3(0.56, -0.12, 0.0), 0.045)), sdCap(p, vec3(-0.56, -0.12, 0.0), vec3(0.56, -0.12, 0.0), 0.045));',
    '  float pole = sdCylY(p - vec3(0.0, -0.62, 0.0), 0.05, 0.52);',
    '  float l1 = sdCap(p, vec3(0.0, -1.1, 0.0), vec3(0.62, -1.4, 0.0), 0.04);',
    '  float l2 = sdCap(p, vec3(0.0, -1.1, 0.0), vec3(-0.31, -1.4, 0.54), 0.04);',
    '  float l3 = sdCap(p, vec3(0.0, -1.1, 0.0), vec3(-0.31, -1.4, -0.54), 0.04);',
    '  return min(min(can, yoke), min(pole, min(l1, min(l2, l3))));',
    '}',
    /* 3 Clapperboard, clapping */
    'float clap(vec3 p){',
    '  float slate = sdBox(p - vec3(0.0, -0.18, 0.0), vec3(0.95, 0.68, 0.05), 0.05);',
    '  float st = 0.012 * smoothstep(0.4, 1.0, sin((p.x + p.y) * 11.0));',
    '  float s1 = sdBox(p - vec3(0.0, 0.62, 0.0), vec3(0.95, 0.1, 0.06), 0.02) + st;',
    '  vec3 q = p - vec3(-0.95, 0.74, 0.0);',
    '  q.xy *= rot(-0.38 * (0.5 + 0.5 * sin(uTime * 2.4)));',
    '  float s2 = sdBox(q - vec3(0.95, 0.1, 0.0), vec3(0.95, 0.09, 0.06), 0.02) + 0.012 * smoothstep(0.4, 1.0, sin((q.x - q.y) * 11.0));',
    '  return min(slate, min(s1, s2));',
    '}',
    /* 4 Remote control */
    'float remote(vec3 p){',
    '  vec3 q = p; q.xy *= rot(0.3);',
    '  float body = sdBox(q, vec3(0.3, 1.15, 0.11), 0.1);',
    '  vec3 b = q - vec3(0.0, 0.05, 0.13);',
    '  vec2 cell = vec2(0.17, 0.2);',
    '  vec2 id = clamp(floor(b.xy / cell + 0.5), vec2(-1.0, -2.0), vec2(1.0, 1.0));',
    '  float btn = length(b - vec3(id * cell, 0.0)) - 0.055;',
    '  float pw = length(q - vec3(0.0, 0.85, 0.12)) - 0.08;',
    '  return smin(body, min(btn, pw), 0.03);',
    '}',
    /* 5 Tablet */
    'float tablet(vec3 p){',
    '  vec3 q = p; q.yz *= rot(-0.2); q.xy *= rot(-0.12);',
    '  float body = sdBox(q, vec3(0.85, 1.12, 0.05), 0.09);',
    '  return max(body, -sdBox(q - vec3(0.0, 0.0, 0.06), vec3(0.75, 1.02, 0.02), 0.05));',
    '}',
    /* 6 Phone */
    'float phone(vec3 p){',
    '  vec3 q = p; q.xy *= rot(0.15);',
    '  float body = sdBox(q, vec3(0.46, 0.94, 0.06), 0.14);',
    '  body = max(body, -sdBox(q - vec3(0.0, 0.0, 0.07), vec3(0.4, 0.87, 0.02), 0.11));',
    '  float bump = sdBox(q - vec3(-0.2, 0.66, -0.07), vec3(0.15, 0.15, 0.03), 0.06);',
    '  return min(body, bump);',
    '}',
    /* 7 Laptop */
    'float laptop(vec3 p){',
    '  p.xz *= rot(-0.35);',
    '  float base = sdBox(p - vec3(0.0, -0.55, 0.15), vec3(1.05, 0.04, 0.7), 0.04);',
    '  base = max(base, -sdBox(p - vec3(0.0, -0.5, 0.05), vec3(0.85, 0.02, 0.35), 0.01));',
    '  vec3 q = p - vec3(0.0, -0.53, -0.55); q.yz *= rot(-0.25);',
    '  float lid = sdBox(q - vec3(0.0, 0.7, 0.0), vec3(1.05, 0.7, 0.035), 0.04);',
    '  lid = max(lid, -sdBox(q - vec3(0.0, 0.72, 0.045), vec3(0.95, 0.6, 0.012), 0.02));',
    '  return min(base, lid);',
    '}',

    'float shape(int i, vec3 p){',
    '  if (i == 0) return tv(p);',
    '  if (i == 1) return cam(p);',
    '  if (i == 2) return lamp(p);',
    '  if (i == 3) return clap(p);',
    '  if (i == 4) return remote(p);',
    '  if (i == 5) return tablet(p);',
    '  if (i == 6) return phone(p);',
    '  return laptop(p);',
    '}',

    'float map(vec3 p){',
    '  p.xz *= rot(sin(uTime * 0.3) * 0.55 + uMouse.x * 0.6);',
    '  p.yz *= rot(0.1 + uMouse.y * 0.3);',
    '  float a = shape(uA, p);',
    '  float d = a;',
    '  if (uMix > 0.001) d = mix(a, shape(uB, p), uMix);',
    '  float melt = 0.02 + 0.13 * sin(3.14159 * uMix);',
    '  d += melt * sin(p.x * 4.0 + uTime * 1.3) * sin(p.y * 3.5 - uTime * 1.1) * sin(p.z * 4.2 + uTime * 0.9);',
    '  for (int k = 0; k < 3; k++) {',
    '    float fk = float(k);',
    '    vec3 c = vec3(sin(uTime * 0.6 + fk * 2.1) * 1.7, cos(uTime * 0.8 + fk * 1.7) * 1.05, sin(uTime * 0.45 + fk * 2.9) * 0.9);',
    '    d = smin(d, length(p - c) - (0.13 + 0.04 * sin(uTime * 1.3 + fk)), 0.5);',
    '  }',
    '  return d * 0.72;',
    '}',

    'vec3 normalAt(vec3 p){',
    '  vec2 e = vec2(1.0, -1.0) * 0.0018;',
    '  return normalize(e.xyy * map(p + e.xyy) + e.yyx * map(p + e.yyx) + e.yxy * map(p + e.yxy) + e.xxx * map(p + e.xxx));',
    '}',

    /* Studio environment in Magix blues with white softboxes */
    'vec3 env(vec3 d){',
    '  float y = d.y;',
    '  vec3 c = mix(vec3(0.0, 0.01, 0.32), vec3(0.5, 0.53, 1.0), smoothstep(-0.6, 0.8, y));',
    '  c += vec3(1.0) * smoothstep(0.07, 0.0, abs(y - 0.12)) * 0.95;',
    '  c += vec3(1.0) * smoothstep(0.72, 0.95, y) * 1.3;',
    '  c += vec3(0.9, 0.92, 1.0) * smoothstep(0.8, 0.97, abs(d.x)) * smoothstep(0.65, 0.0, abs(y)) * 1.1;',
    '  c += vec3(0.75, 0.78, 1.0) * smoothstep(0.9, 0.99, d.z) * 0.6;',
    '  c *= mix(0.22, 1.0, smoothstep(-0.9, -0.05, y));',
    '  return c;',
    '}',

    'void main(){',
    '  vec2 uv = (gl_FragCoord.xy - 0.5 * uRes) / uRes.y;',
    '  vec3 ro = vec3(0.0, 0.05, uCamZ);',
    '  vec3 rd = normalize(vec3(uv, -1.8));',
    '  float b = dot(ro, rd), c = dot(ro, ro) - 2.6 * 2.6, h = b * b - c;',
    '  if (h < 0.0) { gl_FragColor = vec4(0.0); return; }',
    '  h = sqrt(h);',
    '  float t = max(-b - h, 0.0), tmax = -b + h;',
    '  bool hit = false;',
    '  for (int i = 0; i < 80; i++) {',
    '    float d = map(ro + rd * t);',
    '    if (d < 0.0012 * t) { hit = true; break; }',
    '    t += d;',
    '    if (t > tmax) break;',
    '  }',
    '  if (!hit) { gl_FragColor = vec4(0.0); return; }',
    '  vec3 p = ro + rd * t;',
    '  vec3 n = normalAt(p);',
    '  vec3 r = reflect(rd, n);',
    '  float fre = pow(1.0 - max(dot(n, -rd), 0.0), 3.0);',
    '  vec3 col = env(r) * mix(vec3(0.8, 0.83, 1.0), vec3(1.05), fre);',
    '  col += pow(max(dot(r, normalize(vec3(0.4, 0.8, 0.5))), 0.0), 48.0) * 1.3;',
    '  col = col / (1.0 + col * 0.3);',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'
  ].join('\n');

  function compile(type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src); gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { console.warn(gl.getShaderInfoLog(s)); return null; }
    return s;
  }
  var vs = compile(gl.VERTEX_SHADER, VS), fs = compile(gl.FRAGMENT_SHADER, FS);
  if (!vs || !fs) return;
  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { console.warn(gl.getProgramInfoLog(prog)); return; }
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'a');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var U = {};
  ['uRes', 'uTime', 'uMouse', 'uCamZ', 'uA', 'uB', 'uMix'].forEach(function (n) { U[n] = gl.getUniformLocation(prog, n); });

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var quality = 1;
  var camZ = 6.4;

  function size() {
    var w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    canvas.width = Math.max(1, Math.round(w * dpr * quality));
    canvas.height = Math.max(1, Math.round(h * dpr * quality));
    gl.viewport(0, 0, canvas.width, canvas.height);
    var aspect = w / h;
    camZ = aspect < 1.1 ? 6.4 * Math.min(window.innerWidth <= 700 ? 1.3 : 1.9, 1.1 / aspect) : 6.4;   /* phones: pulled in closer so the chrome object fills more of the screen */
    draw(time);
  }

  var tx = 0, ty = 0, mx = 0, my = 0;
  window.addEventListener('pointermove', function (e) {
    tx = (e.clientX / window.innerWidth - 0.5);
    ty = (e.clientY / window.innerHeight - 0.5);
  }, { passive: true });

  var PERIOD = 4.4, COUNT = 8;
  function smooth(a, b, x) { var t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); }

  var time = 1.0;
  function draw(t) {
    mx += (tx - mx) * 0.05; my += (ty - my) * 0.05;
    var idx = Math.floor(t / PERIOD) % COUNT;
    var f = (t % PERIOD) / PERIOD;
    gl.uniform2f(U.uRes, canvas.width, canvas.height);
    gl.uniform1f(U.uTime, t);
    gl.uniform2f(U.uMouse, mx, my);
    gl.uniform1f(U.uCamZ, camZ);
    gl.uniform1i(U.uA, idx);
    gl.uniform1i(U.uB, (idx + 1) % COUNT);
    gl.uniform1f(U.uMix, smooth(0.58, 1.0, f));
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }

  /* Loop: pauses off-screen, adapts resolution if frames run slow */
  var visible = true, running = false, t0 = performance.now(), last = 0, slow = 0, fast = 0, frames = 0;
  function frame(now) {
    if (!visible || document.hidden || reduce.matches) { running = false; return; }
    var dt = last ? now - last : 16; last = now;
    frames++;
    if (frames > 20) {
      slow = slow * 0.9 + (dt > 34 ? 1 : 0) * 0.1;
      fast = fast * 0.95 + (dt < 20 ? 1 : 0) * 0.05;
      if (slow > 0.6 && quality > 0.72) { quality = Math.max(0.7, quality - 0.1); slow = 0; fast = 0; size(); }
      else if (fast > 0.9 && quality < 1) { quality = Math.min(1, quality + 0.1); fast = 0; size(); }
    }
    time = 1.0 + (now - t0) / 1000;
    draw(time);
    requestAnimationFrame(frame);
  }
  function start() {
    if (reduce.matches) { draw(time); return; }
    if (running) return;
    running = true; last = 0; requestAnimationFrame(frame);
  }

  if (window.ResizeObserver) new ResizeObserver(size).observe(canvas);
  else window.addEventListener('resize', size);
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); }).observe(canvas);
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
  if (reduce.addEventListener) reduce.addEventListener('change', start);
  size();
  start();
})();
